export default "__VITE_ASSET__bca3aa91__"